import AuthView from '@/modules/auth/views/AuthView.vue'

export const authRoutes = [
  {
    path: '/auth',
    name: 'auth',
    component: AuthView
  }
]